import { render, staticRenderFns } from "./OrderStatus.vue?vue&type=template&id=b11114fc&"
import script from "./OrderStatus.vue?vue&type=script&lang=ts&"
export * from "./OrderStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports